<template>
    <!-- 订单退款 -->
    <a-modal
    title="票券退款详情"
    :visible="visibleRefund"
    @cancel="closeModalRefund"
    @ok="closeModalRefund"
    :destroyOnClose="true"
    class="billInfo"
    :width="1000">
        <a-row class="mb16">
            <a-col :span="8">购买者手机号：{{detailData.tradeRefundVo.phone}}</a-col>
            <a-col :span="8">下单时间：{{detailData.tradeRefundVo.transTime}}</a-col>
            <a-col :span="8">购买途径: {{detailData.tradeRefundVo.platform}}</a-col>
        </a-row>
        <a-row class="mb16">
            <a-col :span="8">退款单号: {{detailData.tradeRefundVo.refundNo}}</a-col>
            <a-col :span="8">交易订单号：{{detailData.tradeRefundVo.transNo}}</a-col>
        </a-row>
        <a-table
        bordered
        :dataSource="refundList"
        :columns="columns"
        :pagination="false"
        :scroll="{y:300}"
        :rowKey="(record,index) => index"
        >
            <span slot="index" slot-scope="a,b,c">{{c+1}}</span>
            <span slot="goodsName" slot-scope="goodsName,row">{{row.isBonus ?'【加赠】':row.isGift?'【赠】':''}}{{goodsName}}</span>
            <span slot="num" slot-scope="num">{{num == -1 ? "不限次" : num ? num : "-"}}</span>
            <span slot="amount" slot-scope="amount">{{amount | momeyFormat(2)}}</span>
        </a-table>
        <div class="mt16 border-gray">
            <a-row class="mb16">
                <a-col class="red" :span="12">申请退款金额/元：{{detailData.tradeRefundVo.applayRefundAmount | momeyFormat(2)}} 元</a-col>
                <a-col class="red" :span="12">订单已退款金额/元：{{detailData.tradeRefundVo.refundAmount | momeyFormat(2)}} 元</a-col>
            </a-row>
            <a-row class="">
                <a-col class="red" :span="12">订单应收金额/元：{{detailData.tradeRefundVo.transAmount | momeyFormat(2)}} 元</a-col>
                <a-col class="red" :span="12">订单实收金额/元：{{detailData.tradeRefundVo.payAmount | momeyFormat(2)}} 元</a-col>
            </a-row>
        </div>
        <div class="mt16 border-gray">
            <a-row class="mb16">
                <a-col class="red" :span="12">申请退款积分：{{detailData.tradeRefundVo.applayRefundPoint}} 积分</a-col>
                <a-col class="red" :span="12">订单已退款积分：{{detailData.tradeRefundVo.refundPoint}} 积分</a-col>
            </a-row>
            <a-row class="">
                <a-col class="red" :span="12">订单应收积分：{{detailData.tradeRefundVo.transPoint}} 积分</a-col>
                <a-col class="red" :span="12">订单实收积分：{{detailData.tradeRefundVo.payPoint}} 积分</a-col>
            </a-row>
        </div>
        <div class="mt16 border-gray">
            <a-row class="mb16">
                <a-col class="red" :span="12">收银台优惠使用：{{detailData.tradeRefundVo.discountName || '--'}}</a-col>
                <a-col class="red" :span="12">收银台优惠抵扣金额：{{detailData.tradeRefundVo.discountAmount | momeyFormat(2)}} 元</a-col>
            </a-row>
            <a-row class="">
                <a-col class="red" :span="12">优惠券使用：{{detailData.tradeRefundVo.couponName || '--'}}</a-col>
                <a-col class="red" :span="12">优惠券抵扣金额：{{detailData.tradeRefundVo.couponAmount | momeyFormat(2)}} 元</a-col>
            </a-row>
        </div>
        <div class="border-gray mt16">
            <a-row class="mb16">
                <a-col :span="12">退款类型：{{detailData.tradeRefundVo.remarkCategoryName}}</a-col>
                <a-col :span="12">退款原因：{{detailData.reason}}</a-col>
            </a-row>
            <a-row class="mb16">
                <a-col :span="12">审批人：{{detailData.reviewerName}}</a-col>
                <a-col :span="12">申请时间：{{detailData.submitTime}}</a-col>
            </a-row>
            <a-row class="mb16">
                <a-col :span="12">审核状态：{{$utils.auditState[String(detailData.state)]}}</a-col>
                <a-col :span="12">审核时间：{{detailData.approvalTime || '-'}}</a-col>
            </a-row>
            <div v-if="isVerify">
                <span class="text-fail mr8">*</span><span>是否发送短信通知：</span>
                <a-radio-group v-model="isSendMessage">
                    <a-radio :value="1">是</a-radio>
                    <a-radio :value="0">否</a-radio>
                </a-radio-group>
            </div>
        </div>
        <div slot="footer"></div>
        <!-- getBtnByAuth('verifyResult') &&  -->
        <div v-if="isVerify" slot="footer" class="text-center mt16 mb16">
            <a-button :loading="noLoading" @click="OAapprovalUnpass(1)">审批不通过</a-button>
            <a-button :loading="yesLoading" type="primary" @click="OAapprovalPass(1)">审批通过并退款</a-button>
        </div>
        <div v-else-if="!isVerify && detailData.state == 0" slot="footer" class="text-center mt16 mb16">
            <a-button type="primary" @click="OAapprovalCancel(1)">撤回</a-button>
        </div>
    </a-modal>
</template>

<script>

    /**
     * 退款审核组件
     * @prop {Boolean} isVerify 是展示审核操作,否展示详情
     * @prop {String} verifyId 审核记录ID
     * @prop {Boolean} visibleRefund 控制退款弹窗是否显示
     *
     * @func closeModalRefund 通知父组件关闭退款弹窗
     */
    import memberCard from "@/components/modules/order/member-card.component";
    import { mapGetters } from "vuex";
    const columns = [
    {
        title: "序号",
        dataIndex: "index",
        width: 50,
        scopedSlots: { customRender: "index" }
    },
    {
        title: "商品名称",
        dataIndex: "goodsName",
        width: 120,
        scopedSlots: { customRender: "goodsName" }
    },
    {
        title: "总次数",
        dataIndex: "total",
        scopedSlots: { customRender: "num" }
    },
    {
        title: "票券剩余次数",
        dataIndex: "residueNum",
        scopedSlots: { customRender: "num" }
    },
    {
        title: "实付金额",
        dataIndex: "payAmount",
        scopedSlots: { customRender: "amount" },
    },
    {
        title: "可退金额",
        dataIndex: "refundableAmount",
        scopedSlots: { customRender: "amount" },
    },
    {
        title: "退款金额",
        dataIndex: "refundAmount",
        scopedSlots: { customRender: "amount" },
    }
    ];
    export default {
        name: "member-order-refund",
        zh: "退款组件",
        data() {
            return {
                columns,
                detailData: {
                    tradeRefundVo: {
                        goods: [],
                    },
                },
                refundList: [],
                currentRoleId: 0,
                allcJob: '',
                copyUserId: '',
                yesLoading: false,
                noLoading: false,
                isNeedModal: false,
                isSendMessage: undefined,
                payMode: undefined,
                isManualPayment: undefined,
            };
        },
        props: {
            visibleRefund: {type: Boolean},
            isVerify: {type: Boolean},
            verifyId: {type: String},
            businessId: {type: String, default: ""}
        },
        components: {
            memberCard,
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            getData() {
                this.$api.audit.orderRefund({
                    params: {
                        refundNo: this.verifyId
                    }
                }).then(res => {
                    this.refundList = [];
                    if (res.tradeRefundVo && res.tradeRefundVo.goods) {
                        res.tradeRefundVo.goods.forEach(el => {
                            this.refundList.push(el)
                            el.gifts && this.refundList.push(...el.gifts)
                        });
                    }
                    this.detailData = res;
                }).catch(err => {
                    this.refundList = [];
                })
            },
            // 获取审批后详情
            getDetail() {
                this.$api.audit.isNeedAlert({
                    params: {
                        id: this.verifyId,
                    }
                }).then(res => {
                    this.isNeedModal = res.isNeedAlert;
                    this.payMode = res.payMode;
                    this.isManualPayment = res.isManualPayment;
                    if(!res.isNeedAlert) {
                        this.$message.success("审核成功！");
                    }
                    this.closeModalRefund();
                });
            },

            closeModalRefund() {
                this.$eventBus.emit('refreshAutid');
                this.$emit('changeVisibleRefund', {visibleOrderRefundOrder: false, isNeedModal: this.isNeedModal, payMode: this.payMode, isManualPayment: this.isManualPayment})
            },
            /**
             * @roleChange {method} 角色选择框改变事件
             */
            roleChange(value) {
                this.currentRoleId = value;
            },
            /**
             * @OAapproval {method} 审核通过提交事件
             * @approvalId {number} 审核id,
             */
            OAapprovalPass(type) {
                if (this.$moment().day() == 1 || (this.$moment().format('H') < 10 || this.$moment().format('H') >= 23)) {
                    this.$message.warn('当前银联系统收款账户清算中，暂不支持退款。每周一全天和其他日期的23点-次日10点管理后台和小程序都不支持退款。');
                    return
                };
                if(this.isVerify && this.isSendMessage != 0 && this.isSendMessage != 1) {
                    this.$message.error('请先选择是否发送短信通知')
                    return
                }
                this.yesLoading = true;
                this.$api.audit.passp({
                    body: {
                        id: this.verifyId,
                        isSendMessage: this.isSendMessage,
                        state: 1
                    }
                })
                .then(data => {
                    this.yesLoading = false
                    this.getDetail();
                }).catch(err => {
                    this.yesLoading = false
                })
            },
            OAapprovalCancel() {
                this.$api.audit.cancel({
                    params: {
                        id: this.verifyId,
                    }
                })
                .then(data => {
                    this.$message.success("撤回成功！");
                    this.closeModalRefund()
                });
            },
            /**
             * @OAapproval {method} 审核不通过提交事件
             * @approvalId {number} 审核id,
             */
            OAapprovalUnpass(type) {
                this.noLoading = true;
                this.$api.audit.unPass({
                    params: {
                        id: this.verifyId,
                    }
                }).then(data => {
                    this.noLoading = false
                    this.$message.success("审核成功！");
                    this.closeModalRefund()
                }).catch( err => {
                    this.noLoading = false;
                })
            },
        },
        mounted() {
            // this.getSysRoleList();
            // this.getSysUserList();
        },
        watch: {
            'visibleRefund'(val) {
                val && this.getData()
                this.isNeedModal = false;
                this.isSendMessage = undefined
            },
            'shopId'() {
                // this.getSysRoleList()
            }
        }
    };
</script>

<style lang="scss">
    .refund-box .ant-row {
        line-height: 32px;
    }
    .billInfo {
        .red {
            color: rgba(245, 34, 45, 1);
        }
        .border-gray{
            border:1px solid #ddd;
            padding: 16px;
        }
    }
</style>
